module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12,
      "lg": 12
    }
  }, [(_vm.$store.getters.login_type != 'distributor') ? _c('shop-select', {
    attrs: {
      "distributors": ""
    },
    on: {
      "update": _vm.storeSearch
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "开始日期",
      "ange-separator": "至",
      "end-placeholder": "结束日期",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择订单类型",
      "size": "mini"
    },
    on: {
      "change": _vm.TypeHandle
    },
    model: {
      value: (_vm.order_class),
      callback: function($$v) {
        _vm.order_class = $$v
      },
      expression: "order_class"
    }
  }, _vm._l((_vm.order_class_array), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入来源",
      "size": "mini"
    },
    on: {
      "select": _vm.sourceSearch
    },
    model: {
      value: (_vm.source_name),
      callback: function($$v) {
        _vm.source_name = $$v
      },
      expression: "source_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "导购员手机号",
      "size": "mini"
    },
    model: {
      value: (_vm.salesman_mobile),
      callback: function($$v) {
        _vm.salesman_mobile = $$v
      },
      expression: "salesman_mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号/订单号",
      "size": "mini"
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择支付方式类型",
      "size": "mini"
    },
    on: {
      "change": _vm.TypePayHandle
    },
    model: {
      value: (_vm.pay_type),
      callback: function($$v) {
        _vm.pay_type = $$v
      },
      expression: "pay_type"
    }
  }, _vm._l((_vm.pay_type_array), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品货号，多个货号间使用英文逗号分割",
      "size": "mini"
    },
    model: {
      value: (_vm.item_bn),
      callback: function($$v) {
        _vm.item_bn = $$v
      },
      expression: "item_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.itemBnSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 3,
      "lg": 3
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部订单",
      "size": "mini"
    },
    on: {
      "change": _vm.TypePayHandle
    },
    model: {
      value: (_vm.merchant_type),
      callback: function($$v) {
        _vm.merchant_type = $$v
      },
      expression: "merchant_type"
    }
  }, _vm._l((_vm.merchantType), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 3,
      "lg": 3
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部订单",
      "size": "mini"
    },
    on: {
      "change": _vm.sourceChange
    },
    model: {
      value: (_vm.push_to_youxuan_status),
      callback: function($$v) {
        _vm.push_to_youxuan_status = $$v
      },
      expression: "push_to_youxuan_status"
    }
  }, _vm._l((_vm.sourceType), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 3,
      "lg": 3
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "取货方式",
      "size": "mini"
    },
    on: {
      "change": _vm.receiptTypeChange
    },
    model: {
      value: (_vm.receipt_type),
      callback: function($$v) {
        _vm.receipt_type = $$v
      },
      expression: "receipt_type"
    }
  }, _vm._l((_vm.receiptType), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 6,
      "lg": 5
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportData('normal_master_order')
      }
    }
  }, [_vm._v("导出主订单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportData('normal_order')
      }
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单下载",
      "visible": _vm.downloadView,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.downloadView = $event
      }
    }
  }, [(_vm.downloadUrl) ? [_c('a', {
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.downloadName))])] : _vm._e()], 2), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待发货",
      "name": "notship"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待收货",
      "name": "WAIT_BUYER_CONFIRM"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完成",
      "name": "done"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "未支付",
      "name": "notpay"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "取消待审核",
      "name": "cancelapply"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "cancel"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 190,
      "element-loading-text": "数据加载中"
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": "",
            "label-width": "120px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "所属店铺"
          }
        }, [(scope.row.distributor_name) ? _c('span', [_vm._v(_vm._s(scope.row.distributor_name))]) : _c('span', [_vm._v("总部-怡康大庆路二店")])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "运费"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.fee_symbol) + _vm._s(scope.row.freight_fee / 100))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "订单类型"
          }
        }, [(scope.row.order_class == 'normal') ? _c('span', [_vm._v("普通订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_class == 'groups') ? _c('span', [_vm._v("团购订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_class == 'seckill') ? _c('span', [_vm._v("秒杀订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_class == 'community') ? _c('span', [_vm._v("社区订单")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "是否为服务订单"
          }
        }, [(scope.row.is_settle_in_service == '1') ? _c('span', [_vm._v("服务")]) : (scope.row.is_settle_in_service == '0') ? _c('span', [_vm._v("普通")]) : _vm._e()])], 1)]
      }
    }], null, false, 3738031767)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "label": "订单号",
      "fixed": ""
    }
  }), _vm._v(" "), (_vm.params.order_status != 'cancelapply') ? _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2176513052)
  }) : _c('el-table-column', {
    attrs: {
      "prop": "cancel_time",
      "label": "申请退款时间",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.cancel_time > 0) ? [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.cancel_time, 'yyyy-MM-dd hh:mm:ss')))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_fee",
      "width": "75",
      "label": "金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100) + "\n            ")]
      }
    }], null, false, 2197525697)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "width": "111",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "处方审核",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.prescription_order_status == 0 && scope.row.order_drug == 1) ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (scope.row.prescription_order_status == 1 && scope.row.order_drug == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已通过")]) : _vm._e(), _vm._v(" "), (scope.row.prescription_order_status == 2 && scope.row.order_drug == 1) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("未通过")]) : _vm._e()]
      }
    }], null, false, 2788356533)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_status",
      "label": "订单状态",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_status == 'PAYED') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已支付")]) : (scope.row.order_status == 'NOTPAY') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未支付")]) : (scope.row.order_status == 'CANCEL') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已取消")]) : (scope.row.order_status == 'WAIT_BUYER_CONFIRM' && scope.row.cancel_status == 'NO_APPLY_CANCEL') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("待收货")]) : (scope.row.order_status == 'REFUND_SUCCESS') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(" 已退款")]) : (scope.row.order_status == 'WAIT_GROUPS_SUCCESS') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(" 等待成团")]) : (scope.row.order_status == 'DONE') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已完成")]) : (scope.row.order_status == 'WAIT_BUYER_CONFIRM' && scope.row.cancel_status == 'SUCCESS') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("售后已处理")]) : _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("异常")]), _vm._v(" "), (scope.row.order_status != 'CANCEL' && scope.row.order_status != 'REFUND_SUCCESS' && scope.row.order_status != 'WAIT_GROUPS_SUCCESS') ? [(scope.row.delivery_status == 'DONE') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已发货")]) : (scope.row.delivery_status == 'PARTAIL') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("部分发货")]) : (scope.row.cancel_status == 'WAIT_PROCESS') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(" 取消待退款")]) : (scope.row.ziti_status == 'PENDING') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("待自提")]) : (scope.row.ziti_status == 'DONE') ? _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已自提")]) : _c('el-tag', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("待发货")])] : _vm._e()]
      }
    }], null, false, 3048597750)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "push_to_erp_status",
      "label": "推送状态",
      "width": "95",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.push_to_erp_status == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未推送")]) : (scope.row.push_to_erp_status == '') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未推送")]) : (scope.row.push_to_erp_status == null) ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未推送")]) : (scope.row.push_to_erp_status == '1') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已推送")]) : (scope.row.push_to_erp_status == '2') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("推送失败")]) : (scope.row.push_to_erp_status == '3') ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("推送中...")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (scope.row.push_to_youxuan_status == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("优选未推送")]) : (scope.row.push_to_youxuan_status == '11') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("优选未推送")]) : (scope.row.push_to_youxuan_status == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("优选已推送")]) : (scope.row.push_to_youxuan_status == '2') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("优选不推送")]) : _vm._e()]
      }
    }], null, false, 1810409860)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pay_type",
      "label": "支付类型",
      "width": "110",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pay_type == 'wxpay') ? _c('span', [_vm._v("微信支付")]) : (scope.row.pay_type == 'wxpaypc') ? _c('span', [_vm._v("微信PC支付")]) : (scope.row.pay_type == 'wxpayapp') ? _c('span', [_vm._v("微信APP支付")]) : (scope.row.pay_type == 'alipay') ? _c('span', [_vm._v("支付宝支付")]) : (scope.row.pay_type == 'alipayapp') ? _c('span', [_vm._v("支付宝APP支付")]) : (scope.row.pay_type == 'alipayxapp') ? _c('span', [_vm._v("支付宝小程序支付")]) : (scope.row.pay_type == 'yaoking_deposit') ? _c('span', [_vm._v("商城预存款")]) : (scope.row.pay_type == 'yibaopay') ? _c('span', [_vm._v("省医保")]) : (scope.row.pay_type == 'jh_digital') ? _c('span', [_vm._v("交行数字快捷支付")]) : (scope.row.pay_type == 'jsapi') ? _c('span', [_vm._v("微信H5支付")]) : (scope.row.pay_type == 'wxpayh5') ? _c('span', [_vm._v("微信H5支付")]) : (scope.row.pay_type == 'spdb_h5_xppay') ? _c('span', [_vm._v("浦发小浦支付")]) : (scope.row.pay_type == 'ccb_h5_digital') ? _c('span', [_vm._v("建行数字货币支付")]) : (scope.row.pay_type == 'SCAN_ALIPAY') ? _c('span', [_vm._v("商家支付宝支付")]) : (scope.row.pay_type == 'WECHATPAY_MINIPROGRAM') ? _c('span', [_vm._v("商家微信小程序支付")]) : (scope.row.pay_type == 'benefit') ? _c('span', [_vm._v("优卡支付")]) : (scope.row.pay_type == 'peihepay') ? _c('span', [_vm._v("沛合直付")]) : (scope.row.pay_type == 'fuioupay_miniprogram') ? _c('span', [_vm._v("富友微信小程序支付")]) : (scope.row.pay_type == 'corporate_pay') ? _c('span', [_vm._v("对公打款")]) : _vm._e()]
      }
    }], null, false, 11926760)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receipt_type",
      "label": "配送方式",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.receipt_type == 'ziti') ? _c('span', [_vm._v("自提")]) : (scope.row.receipt_type == 'logistics') ? _c('span', [_vm._v("及时配送")]) : (scope.row.receipt_type == 'express') ? _c('span', [_vm._v("快递配送")]) : _vm._e()]
      }
    }], null, false, 2850451383)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source_name",
      "label": "来源",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "管理员备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.admin_remarks) ? _c('span', [_vm._v(_vm._s(scope.row.admin_remarks))]) : _vm._e()]
      }
    }], null, false, 1149105177)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('detail'),
              query: {
                orderId: scope.row.order_id,
                resource: _vm.$route.path,
                order_menu_status: _vm.params.order_status
              }
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), (scope.row.pay_type == 'corporate_pay' && scope.row.order_status == 'NOTPAY' && scope.row.cancel_status == 'NO_APPLY_CANCEL') ? _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.corporateAuditAction(scope.row.order_id)
            }
          }
        }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), (scope.row.cancel_status == 'NO_APPLY_CANCEL' && (scope.row.order_status == 'NOTPAY' || scope.row.order_status == 'PAYED')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.cancelOrderAction(scope.row.order_id)
            }
          }
        }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_drug == '1') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.order_drug_detail(scope.row.order_id)
            }
          }
        }, [_vm._v("处方详情")]) : _vm._e(), _vm._v(" "), (scope.row.order_drug == '1') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateDrug(scope.row.order_id)
            }
          }
        }, [_vm._v("处方更新")]) : _vm._e(), _vm._v(" "), (!_vm.IsBind) ? _c('span', [(scope.row.receipt_type == 'express' && scope.row.order_status == 'PAYED') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.ReDeliveryAction(scope.row)
            }
          }
        }, [_vm._v("补录快递单号")]) : _vm._e(), _vm._v(" "), (scope.row.cancel_status == 'WAIT_PROCESS' && scope.row.order_status == 'PAYED') ? _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.confirmCancelOrderAction(scope.row.order_id)
            }
          }
        }, [_vm._v("退款")]) : _vm._e(), _vm._v(" "), (scope.row.cancel_status == 'NO_APPLY_CANCEL' && scope.row.order_status == 'PAYED') ? _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDoneOrderAction(scope.row.order_id)
            }
          }
        }, [_vm._v("完成订单")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.confirmRemarkOrderAction(scope.row.order_id, scope.row.admin_remarks)
            }
          }
        }, [_vm._v("备注")]), _vm._v(" "), (scope.row.cancel_status == 'WAIT_PROCESS' && (scope.row.order_status == 'PAYED')) ? _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleAbnormal(scope.row.order_id)
            }
          }
        }, [_vm._v("修改订单为已取消")]) : _vm._e(), _vm._v(" "), (scope.row.delivery_status == 'DONE' && (scope.row.push_to_erp_status == '1')) ? _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.refundGoods(scope.row.order_id)
            }
          }
        }, [_vm._v("申请售后")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
          scope.row.delivery_status != 'DONE' &&
          scope.row.ziti_status != 'DONE' &&
          scope.row.order_status != 'CANCEL' &&
          scope.row.push_to_erp_status != '1' &&
          scope.row.cancel_status == 'NO_APPLY_CANCEL' &&
          scope.row.order_status != 'NOTPAY' &&
          scope.row.is_allinpay != '1'
        ) ? _c('span', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.pushOrder(scope.row.order_id)
            }
          }
        }, [_vm._v("手动推送")])], 1) : _vm._e(), _vm._v(" "), (scope.row.push_to_youxuan_status == 11 && scope.row.push_to_erp_status == 1) ? _c('span', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.pushYxOrder(scope.row.order_id)
            }
          }
        }, [_vm._v("推送优选")])], 1) : _vm._e(), _vm._v(" "), (scope.row.admin_remarks && scope.row.admin_remarks.indexOf('cjy_orderid') !== -1 && (scope.row.order_status != 'NOTPAY' && scope.row.order_status != 'CANCEL')) ? _c('span', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.pushMemCenter(scope.row.order_id)
            }
          }
        }, [_vm._v("补推会员中台")])], 1) : _vm._e()]
      }
    }], null, false, 316398437)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.deliveryTitle,
      "visible": _vm.deliveryVisible,
      "before-close": _vm.handleCancel,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.deliveryVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "deliveryForm",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.deliveryForm,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "订单号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_vm._v(_vm._s(_vm.deliveryData.orderInfo.order_id))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "发货类型"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "disabled": _vm.IsDisabled
      },
      model: {
        value: (_vm.deliveryForm.delivery_type),
        callback: function($$v) {
          _vm.$set(_vm.deliveryForm, "delivery_type", $$v)
        },
        expression: "deliveryForm.delivery_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "batch"
      }
    }, [_vm._v("整单发货")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "sep"
      }
    }, [_vm._v("拆分发货")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "商品信息"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 30
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.deliveryData.orderInfo.items
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "num",
        "label": "数量",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "总价(元)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100))])]
        }
      }], null, false, 407753050)
    }), _vm._v(" "), (_vm.deliveryForm.delivery_type == 'sep') ? [_c('el-table-column', {
      attrs: {
        "label": "快递公司",
        "width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-select', {
            attrs: {
              "filterable": "",
              "placeholder": "请选择快递公司，可搜索"
            },
            model: {
              value: (scope.row.delivery_corp),
              callback: function($$v) {
                _vm.$set(scope.row, "delivery_corp", $$v)
              },
              expression: "scope.row.delivery_corp"
            }
          }, _vm._l((_vm.dlycorps), function(item) {
            return _c('el-option', {
              key: item.value,
              attrs: {
                "label": item.name,
                "value": item.value
              }
            })
          }), 1)]
        }
      }], null, false, 1397891712)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "物流单号",
        "width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "maxlength": 20,
              "placeholder": "物流公司单号"
            },
            model: {
              value: (scope.row.delivery_code),
              callback: function($$v) {
                _vm.$set(scope.row, "delivery_code", $$v)
              },
              expression: "scope.row.delivery_code"
            }
          })]
        }
      }], null, false, 2798900684)
    })] : _vm._e()], 2)], 1)], 1), _vm._v(" "), (_vm.deliveryForm.delivery_type == 'batch') ? [_c('el-form-item', {
      attrs: {
        "label": "快递公司"
      }
    }, [_c('el-col', [_c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "请选择快递公司，可搜索"
      },
      model: {
        value: (_vm.deliveryForm.delivery_corp),
        callback: function($$v) {
          _vm.$set(_vm.deliveryForm, "delivery_corp", $$v)
        },
        expression: "deliveryForm.delivery_corp"
      }
    }, _vm._l((_vm.dlycorps), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.name,
          "value": item.value
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "物流单号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "物流公司单号"
      },
      model: {
        value: (_vm.deliveryForm.delivery_code),
        callback: function($$v) {
          _vm.$set(_vm.deliveryForm, "delivery_code", $$v)
        },
        expression: "deliveryForm.delivery_code"
      }
    })], 1)], 1)] : _vm._e()], 2)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitDeliveryAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.ReDeliveryTitle,
      "visible": _vm.ReDeliveryVisible,
      "before-close": _vm.handleCancel,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.ReDeliveryVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "ReDeliveryForm",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.ReDeliveryForm,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "订单号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_vm._v(_vm._s(_vm.ReDeliveryData.orderInfo.order_id))])], 1), _vm._v(" "), [_c('el-form-item', {
      attrs: {
        "label": "快递公司"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "请输入快递公司"
      },
      model: {
        value: (_vm.ReDeliveryForm.delivery_corp),
        callback: function($$v) {
          _vm.$set(_vm.ReDeliveryForm, "delivery_corp", $$v)
        },
        expression: "ReDeliveryForm.delivery_corp"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "物流单号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "物流公司单号"
      },
      model: {
        value: (_vm.ReDeliveryForm.delivery_code),
        callback: function($$v) {
          _vm.$set(_vm.ReDeliveryForm, "delivery_code", $$v)
        },
        expression: "ReDeliveryForm.delivery_code"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "发货时间",
        "width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-date-picker', {
            attrs: {
              "type": "datetime",
              "value-format": "timestamp",
              "placeholder": "选择日期时间"
            },
            model: {
              value: (_vm.ReDeliveryForm.reDeliveryTime),
              callback: function($$v) {
                _vm.$set(_vm.ReDeliveryForm, "reDeliveryTime", $$v)
              },
              expression: "ReDeliveryForm.reDeliveryTime"
            }
          })]
        }
      }], null, false, 2027250958)
    })]], 2)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitReDeliveryAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消订单退款审核",
      "visible": _vm.cancelVisible,
      "before-close": _vm.handleCancelOrderCancel,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.cancelVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 100
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "grid-content"
    }, [_vm._v("订单号:" + _vm._s(_vm.cancelData.order_id))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [(_vm.cancelData.cancel_from == 'buyer') ? _c('span', [_vm._v("取消来源:消费者申请")]) : _c('span', [_vm._v("取消来源:系统自动取消")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("申请时间:" + _vm._s(_vm._f("datetime")(_vm.cancelData.create_time, 'yyyy-MM-dd hh:mm:ss')))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("退款状态:")]), _vm._v(" "), (_vm.cancelData.refund_status == 'WAIT_CHECK') ? _c('span', [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.refund_status == 'FAILS') ? _c('span', [_vm._v("退款失败")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.refund_status == 'SUCCESS') ? _c('span', [_vm._v("退款成功")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.refund_status == 'SHOP_CHECK_FAILS') ? _c('span', [_vm._v("商家审核不通过")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.refund_status == 'WAIT_REFUND') ? _c('span', [_vm._v("等待退款")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("处理进度:")]), _vm._v(" "), (_vm.cancelData.progress == '0') ? _c('span', [_vm._v("待处理")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.progress == '1') ? _c('span', [_vm._v("已取消")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.progress == '2') ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.progress == '3') ? _c('span', [_vm._v("已完成")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("退款金额:" + _vm._s(_vm.cancelData.fee_symbol) + _vm._s(_vm.cancelData.total_fee / 100))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [(_vm.cancelData.pay_type == 'wxpay') ? _c('span', [_vm._v("支付方式:微信支付")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("取消原因:" + _vm._s(_vm.cancelData.cancel_reason))])])], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
      ref: "cancelForm",
      attrs: {
        "model": _vm.cancelForm,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "处理结果:"
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [
      [_c('el-radio', {
        attrs: {
          "label": "0"
        },
        model: {
          value: (_vm.cancelForm.check_cancel),
          callback: function($$v) {
            _vm.$set(_vm.cancelForm, "check_cancel", $$v)
          },
          expression: "cancelForm.check_cancel"
        }
      }, [_vm._v("不同意")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": "1"
        },
        model: {
          value: (_vm.cancelForm.check_cancel),
          callback: function($$v) {
            _vm.$set(_vm.cancelForm, "check_cancel", $$v)
          },
          expression: "cancelForm.check_cancel"
        }
      }, [_vm._v("同意")])]
    ], 2)], 1)], 1), _vm._v(" "), (_vm.cancelForm.check_cancel == '0') ? _c('el-form-item', {
      attrs: {
        "label": "拒绝原因:"
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "placeholder": "请输入拒绝原因"
      },
      model: {
        value: (_vm.cancelForm.shop_reject_reason),
        callback: function($$v) {
          _vm.$set(_vm.cancelForm, "shop_reject_reason", $$v)
        },
        expression: "cancelForm.shop_reject_reason"
      }
    })], 1)], 1)], 1) : _vm._e()], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancelOrderCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitCancelConfirmAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消订单退款审核备注",
      "visible": _vm.remarkVisible,
      "before-close": _vm.handleRemarkOrderCancel,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.remarkVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 100
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-input', {
      staticClass: "input-with-select",
      attrs: {
        "placeholder": "输入退款审核备注",
        "clearable": ""
      },
      model: {
        value: (_vm.remarkData.admin_remarks),
        callback: function($$v) {
          _vm.$set(_vm.remarkData, "admin_remarks", $$v)
        },
        expression: "remarkData.admin_remarks"
      }
    })], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemarkOrderCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitRemarkConfirmAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "处方详情",
      "visible": _vm.drugVisible,
      "before-close": _vm.handleordersdrug,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.drugVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      staticStyle: {
        "border-bottom": "1px solid #dcdfe6"
      }
    }, [_c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v("NO：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_vm._v(" " + _vm._s(_vm.orderDrugInfo.id) + " ")]), _vm._v(" "), _c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v("处方日期：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_vm._v(" " + _vm._s(_vm.orderDrugInfo.open_time) + " ")])], 1), _vm._v(" "), (_vm.orderDrugInfo.pres_type == '图文咨询' || _vm.orderDrugInfo.pres_type == 'userimgcheck') ? _c('el-row', {
      staticStyle: {
        "border-bottom": "1px solid #dcdfe6"
      }
    }, _vm._l((_vm.orderDrugInfo.prescription_img), function(item, index) {
      return _c('el-col', {
        key: index,
        attrs: {
          "span": 7
        }
      }, [_c('img', {
        staticStyle: {
          "width": "70%",
          "height": "70%"
        },
        attrs: {
          "src": item,
          "alt": ""
        },
        on: {
          "click": function($event) {
            return _vm.clickImg(index)
          }
        }
      })])
    }), 1) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "border-bottom": "1px solid #dcdfe6"
      }
    }, [_c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v("姓名：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_vm._v(" " + _vm._s(_vm.orderDrugInfo.patient_name))]), _vm._v(" "), _c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v("性别：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_vm._v(" " + _vm._s(_vm.orderDrugInfo.member_sex) + " ")]), _vm._v(" "), _c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v("年龄：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_vm._v(_vm._s(_vm.orderDrugInfo.member_age))])], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "border-bottom": "1px solid #dcdfe6"
      }
    }, [_c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v("诊断：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_vm._v(" " + _vm._s(_vm.orderDrugInfo.diagnose_result))])], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _vm._l((_vm.yaopinInfo), function(item, index) {
      return _c('el-row', {
        key: index,
        staticStyle: {
          "border-bottom": "1px solid #dcdfe6"
        }
      }, [_c('el-col', {
        staticClass: "content-left",
        attrs: {
          "span": 5
        }
      }, [_c('span', [_vm._v(_vm._s(index + 1) + "：" + _vm._s(item.name))])]), _vm._v(" "), _c('el-col', {
        staticClass: "content-left",
        attrs: {
          "span": 8
        }
      }, [_c('span', [_vm._v(_vm._s(item.drug_spec))])]), _vm._v(" "), _c('el-col', {
        staticClass: "content-left",
        attrs: {
          "span": 8
        }
      }, [_c('span', [_vm._v(_vm._s(item.nums) + _vm._s(item.drug_unit))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
        staticClass: "content-left",
        attrs: {
          "span": 8
        }
      }, [_c('span', [_vm._v("用法用量：" + _vm._s(item.frequencies) + "次/" + _vm._s(item.days) + "天，每次" + _vm._s(item.amounts))])]), _vm._v(" "), _c('el-col', {
        staticClass: "content-left",
        attrs: {
          "span": 8
        }
      }, [_c('span', [_vm._v("其他：" + _vm._s(item.directions))])])], 1)], 1)
    }), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v("诊断医师：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_vm._v(" " + _vm._s(_vm.orderDrugInfo.opener_name) + " ")]), _vm._v(" "), _c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v("审核药师：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_vm._v(" " + _vm._s(_vm.orderDrugInfo.auditor_name) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 10
      }
    }, [_c('h4', [_vm._v("处方医师：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 7
      }
    }), _vm._v(" "), _c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 5
      }
    }, [_c('h4', [_vm._v("调剂：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }), _vm._v(" "), _c('el-col', {
      staticClass: "content-right",
      attrs: {
        "span": 5
      }
    }, [_c('h4', [_vm._v("复核：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    })], 1), _vm._v(" "), _c('el-row', {
      staticClass: "content-center"
    }, [_c('h2', [_vm._v("所购药品")])]), _vm._v(" "), _vm._l((_vm.yaopinInfo), function(item, index) {
      return _c('el-row', {
        key: index,
        staticStyle: {
          "border-bottom": "1px solid #dcdfe6"
        }
      }, [_c('el-row', [_c('el-col', {
        staticClass: "content-left",
        attrs: {
          "span": 3
        }
      }, [_c('h4', [_vm._v("药品名称：")])]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 7
        }
      }, [_vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('el-col', {
        staticClass: "content-left",
        attrs: {
          "span": 3
        }
      }, [_c('h4', [_vm._v("购买数量：")])]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 5
        }
      }, [_vm._v(_vm._s(item.nums))])], 1)], 1)
    }), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v("处方审核状态：")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_vm._v(_vm._s(_vm.orderDrugInfo.zhuangtai))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v("处方审核不通过原因：")])]), _vm._v(" "), (_vm.orderDrugInfo.invalid == 'true') ? _c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.orderDrugInfo.invalid_reason) + _vm._s(_vm.orderDrugInfo.cb_reason))])]) : _vm._e(), _vm._v(" "), (_vm.orderDrugInfo.invalid == 'false') ? _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [(_vm.orderDrugInfo.open_status == 2 && _vm.orderDrugInfo.status == 0) ? _c('span', [_vm._v(_vm._s(_vm.orderDrugInfo.refuse_case))]) : (_vm.orderDrugInfo.open_status == 1 && _vm.orderDrugInfo.status == 0) ? _c('span', [_vm._v("等待药师审核")]) : (_vm.orderDrugInfo.open_status == 1 && _vm.orderDrugInfo.status == 2) ? _c('span', [_vm._v(_vm._s(_vm.orderDrugInfo.cb_reason))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "content-left",
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v("订单审核不通过原因：")])]), _vm._v(" "), (_vm.orderData.prescription_order_status == '2') ? _c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.orderData.prescription_order_deny_reason))])]) : _vm._e()], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleordersdrug.apply(null, arguments)
        }
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "处方详情",
      "visible": _vm.imgVisible,
      "before-close": _vm.imgClose,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.imgVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      staticStyle: {
        "width": "50%",
        "height": "30%",
        "text-align": "center"
      }
    }, [_c('img', {
      staticClass: "image-item",
      staticStyle: {
        "width": "100%",
        "height": "40%"
      },
      attrs: {
        "src": _vm.imgSrc,
        "alt": ""
      }
    })])], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.imgClose.apply(null, arguments)
        }
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "对公打款审核",
      "visible": _vm.corporateAuditVisible,
      "before-close": _vm.handleCorporateAuditCancel,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.corporateAuditVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("订单号：" + _vm._s(_vm.corporateAuditData.orderInfo.order_id))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("下单时间：" + _vm._s(_vm._f("datetime")(_vm.corporateAuditData.orderInfo.create_time, 'yyyy-MM-dd hh:mm:ss')))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("订单金额：" + _vm._s(_vm.corporateAuditData.orderInfo.fee_symbol) + _vm._s(_vm.corporateAuditData.orderInfo.total_fee / 100))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("支付方式：对公打款")])])], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
      ref: "corporateAuditFormRef",
      attrs: {
        "model": _vm.corporateAuditForm,
        "label-width": "120px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "审核结果："
      }
    }, [_c('el-radio-group', {
      on: {
        "change": _vm.handleCorporateAuditResultChange
      },
      model: {
        value: (_vm.corporateAuditForm.audit_result),
        callback: function($$v) {
          _vm.$set(_vm.corporateAuditForm, "audit_result", $$v)
        },
        expression: "corporateAuditForm.audit_result"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "0"
      }
    }, [_vm._v("审核不通过")])], 1)], 1), _vm._v(" "), (_vm.corporateAuditForm.audit_result == '1') ? _c('el-form-item', {
      attrs: {
        "label": "交易流水号："
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": "64",
        "placeholder": "请输入银行交易流水号",
        "clearable": ""
      },
      model: {
        value: (_vm.corporateAuditForm.transaction_id),
        callback: function($$v) {
          _vm.$set(_vm.corporateAuditForm, "transaction_id", $$v)
        },
        expression: "corporateAuditForm.transaction_id"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.corporateAuditForm.audit_result == '0') ? _c('el-form-item', {
      attrs: {
        "label": "不通过原因："
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "resize": "none",
        "placeholder": "请填写审核不通过原因"
      },
      model: {
        value: (_vm.corporateAuditForm.reject_reason),
        callback: function($$v) {
          _vm.$set(_vm.corporateAuditForm, "reject_reason", $$v)
        },
        expression: "corporateAuditForm.reject_reason"
      }
    })], 1) : _vm._e()], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCorporateAuditCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.corporateAuditSubmitting
      },
      on: {
        "click": _vm.submitCorporateAuditAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消订单",
      "visible": _vm.cancelOrderVisible,
      "before-close": _vm.handleCancelOrder,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.cancelOrderVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "cancelForm",
      attrs: {
        "model": _vm.cancelOrderForm,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "订单号:"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_vm._v(_vm._s(_vm.cancelOrderData.orderInfo.order_id))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "取消原因:"
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [
      [_c('el-select', {
        attrs: {
          "filterable": "",
          "placeholder": "请选择取消订单原因"
        },
        on: {
          "change": _vm.cancelReasonSelect
        },
        model: {
          value: (_vm.cancel_order),
          callback: function($$v) {
            _vm.cancel_order = $$v
          },
          expression: "cancel_order"
        }
      }, _vm._l((_vm.order_cancel_reason), function(item) {
        return _c('el-option', {
          key: item.value,
          attrs: {
            "label": item.name,
            "value": item.value
          }
        })
      }), 1), _vm._v(" "), _c('el-input', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.cancelOrderInput),
          expression: "cancelOrderInput"
        }],
        staticStyle: {
          "width": "200px",
          "margin-top": "10px"
        },
        attrs: {
          "type": "textarea",
          "rows": 3,
          "resize": "none",
          "placeholder": "请填写取消订单原因"
        },
        model: {
          value: (_vm.cancelOrderForm.other_reason),
          callback: function($$v) {
            _vm.$set(_vm.cancelOrderForm, "other_reason", $$v)
          },
          expression: "cancelOrderForm.other_reason"
        }
      })]
    ], 2)], 1)], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancelOrder.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitCancelOrderConfirmAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57232c0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57232c0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/normalorders/list.vue
// module id = 2733
// module chunks = 0